module.exports = __webpack_public_path__ + "img/485eee6.png";